// Clé stable des props qui déterminent une requête de stats : deux jeux de props de même clé
// produisent la même requête. Les tableaux sont sérialisés car leur identité change à chaque
// render du parent alors que leur contenu est inchangé.
export default props => {
  const { siteId, experienceId, experienceIds, from, to, excludeZeros, axis, group, axisProperties } = props
  return [
    siteId,
    experienceId,
    (experienceIds || []).filter(Boolean).join(','),
    from,
    to,
    excludeZeros,
    axis,
    group,
    (axisProperties || []).join(',')
  ].join('|')
}
